module.exports = __webpack_public_path__ + "static/media/26-1.a08411c2.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/26-1.JPG
// module id = 1375
// module chunks = 0